import type { CallToolResult } from '@modelcontextprotocol/sdk/types.js';
import type { IFIXParser } from 'fixparser';

export const createParseToJSONHandler = (
    parser: IFIXParser,
): ((args: { fixString: string }) => Promise<CallToolResult>) => {
    return async (args: { fixString: string }): Promise<CallToolResult> => {
        try {
            const parsedMessage = parser.parse(args.fixString);
            if (!parsedMessage || parsedMessage.length === 0) {
                return {
                    content: [
                        {
                            type: 'text',
                            text: 'Error: Failed to parse FIX string',
                            uri: 'parseToJSON',
                        },
                    ],
                    isError: true,
                };
            }

            return {
                content: [
                    {
                        type: 'text',
                        text: `${parsedMessage[0].toFIXJSON()}`,
                        uri: 'parseToJSON',
                    },
                ],
            };
        } catch (error) {
            return {
                content: [
                    {
                        type: 'text',
                        text: `Error: ${error instanceof Error ? error.message : 'Failed to parse FIX string'}`,
                        uri: 'parseToJSON',
                    },
                ],
                isError: true,
            };
        }
    };
};
